import axios from 'axios';

const modicareAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_MODICARE_API_URL_2,
  // baseURL: 'https://uat-api.modicare.com',
  timeout: 30000,
});

modicareAxiosInstance.interceptors.request.use(
  (config) => {
    // Add headers to each request
    config.headers['m-key'] = 'Y8S3TA-7R3NGQ-TPJ9T6-98709';
    config.headers['x-rm'] = 'MW';
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

export default {
  install: (app) => {
    app.config.globalProperties.$modicare_kyc_axios = modicareAxiosInstance ;
    app.provide('modicare_kyc_axios', modicareAxiosInstance );
  },
};
export {modicareAxiosInstance};